const Dom = {
    'body'              : document.getElementsByTagName("body")[0],

    // accesibility
    'focusable'         : document.querySelectorAll("a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), object, embed, *[tabindex], *[contenteditable], *[data-notab]"),

    // Modal
    'modalTrigger'      : document.querySelectorAll('[modal-target]'),
    'closeModal'        : document.querySelectorAll('.modal__close'),
    'closeAnyModal'     : document.querySelectorAll('[data-dismiss="allModal"]'),
    'closeButton'       : document.querySelectorAll('[close-button]'),
}

export default Dom;
